import { createContext, useContext, useEffect, useState } from 'react';
import { SdkProvider, TypeFamily } from '@facephi/sdk-web';
import { useVariables } from '../hooks';
import { useAuth, useConfig } from '../providers';
import { DEFAULT_COUNTRY } from '../states/constants';

type IProps = {
  children: React.ReactNode;
};

type ContextProps = {
  helpVideoAssistance: (id: string) => void;
};

const Ctx = createContext<ContextProps>({
  helpVideoAssistance: () => {},
});

export const ExtendedSdkProvider = ({ children }: IProps) => {
  const {
    appTesting,
    trackingUrl,
    trackingUrlAssets,
    clientId,
    trackingAuthUrl,
    clientSecret,
    videoApiKey,
    cloudApi,
    posthogToken,
    posthogHost,
  } = useVariables();
  const { getWorkflow } = useConfig();
  const { email, tenantDefault } = useAuth();
  const [key, setKey] = useState(0);

  useEffect(() => {
    setKey((key) => key + 1);
  }, [tenantDefault]);

  return (
    <SdkProvider
      key={key}
      bundlePath={`${window.location.origin}/widgets`}
      videoOptions={{
        apiKey: videoApiKey || '',
        baseUrl: cloudApi || '',
        autoStart: false,
      }}
      workflowOptions={{
        bundlePath: `${process.env.PUBLIC_URL}/widgets`,
        workflow: getWorkflow(),
        apiUrl: '',
        testing: appTesting,
        autoStart: false,
        defaultCountry: DEFAULT_COUNTRY,
      }}
      customerId={email}
      trackingOptions={{
        trackingUrl: trackingUrl || '',
        trackingUrlAssets: trackingUrlAssets || '',
        clientId: clientId || '',
        authUrl: trackingAuthUrl || '',
        clientSecret: clientSecret || '',
        tenantId: tenantDefault || '',
        type: TypeFamily.onboarding,
        disabled: appTesting || !trackingUrl,
      }}
      metricsOptions={{
        token: posthogToken || '',
        host: posthogHost || '',
        type: TypeFamily.onboarding,
        clientId: clientId || '',
      }}
    >
      {children}
    </SdkProvider>
  );
};

export const useExtendedSdk = () => useContext(Ctx);
